import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 19v2h16v-14l-8 -4l-8 4v2","key":"svg-0"}],["path",{"d":"M13 14h-9","key":"svg-1"}],["path",{"d":"M7 11l-3 3l3 3","key":"svg-2"}]]

/**
 * IconTransferOut
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdHJhbnNmZXItb3V0Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik00IDE5djJoMTZ2LTE0bC04IC00bC04IDR2MiIgLz4KICA8cGF0aCBkPSJNMTMgMTRoLTkiIC8+CiAgPHBhdGggZD0iTTcgMTFsLTMgM2wzIDMiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/transfer-out
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconTransferOut = createReactComponent('outline', 'transfer-out', 'TransferOut', __iconNode);

export default IconTransferOut;